export type ChatsViewTranslation = {
  button: {
    send: string;
  };
  label: {
    unread: string;
  };
};

export const chatsViewTranslation: ChatsViewTranslation = {
  button: {
    send: 'Wyślij',
  },
  label: {
    unread: 'Nieprzeczytane',
  },
};
